export function getComponentName(component) {
    if ('displayName' in component) {
        return component.displayName;
    }
    if ('name' in component) {
        return component.name;
    }
    return 'Unknown Component';
}
//# sourceMappingURL=getComponentName.js.map